import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import {
  ApplicantsInfo,
  ApplicationBasicInfo,
  ApplicationDetails,
  ApplicationResidentsModel,
  ApplicationUnitModel,
  CoSignerRequiredModel,
  CosignerBulkUpdateModel,
  CosignerListModel,
  ResidentApplicationInfoModel,
} from './models';

export function fetchResidentApplicationsService(
  client: ApiClient = apiClient,
) {
  return client.get<ApplicationDetails[]>(`/residents/applications`);
}

export function createResidentApplicationService() {
  return apiClient.post<{ applicationId: string }>('/residents/applications');
}

export function fetchResidentApplicationService(
  applicationId: string,
  client: ApiClient = apiClient,
) {
  return client.get<ApplicationBasicInfo>(
    `/residents/applications/${applicationId}`,
  );
}

export function fetchResidentApplicationLeaseDetailsService(
  applicationId: string,
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<ApplicationUnitModel>(
    `/residents/applications/${applicationId}/units/${homeId}`,
  );
}

export function updatehResidentApplicationLeaseDetailsService(
  applicationId: string,
  homeId: string,
  leaseDetails: ApplicationUnitModel,
  client: ApiClient = apiClient,
) {
  return client.post<ApplicationUnitModel>(
    `/residents/applications/${applicationId}/units`,
    { units: [leaseDetails] },
  );
}

export function fetchResidentApplicationTenantsService(
  applicationId: string,
  client: ApiClient = apiClient,
) {
  return client.get<ApplicantsInfo>(
    `/residents/applications/${applicationId}/residents`,
  );
}

export function updateResidentApplicationTenantsService(
  applicationId: string,
  tenants: ApplicationResidentsModel,
  client: ApiClient = apiClient,
) {
  return client.put<ApplicantsInfo>(
    `/residents/applications/${applicationId}/residents`,
    tenants,
  );
}

export function fetchResidentApplicationCoSignersService(
  applicationId: string,
  client: ApiClient = apiClient,
) {
  return client.get<CosignerListModel>(
    `/residents/applications/${applicationId}/cosigners`,
  );
}

export function updateResidentApplicationCoSignersService(
  applicationId: string,
  coSigners: CosignerBulkUpdateModel,
  client: ApiClient = apiClient,
) {
  return client.put<CosignerListModel>(
    `/residents/applications/${applicationId}/cosigners`,
    coSigners,
  );
}

export function fetchResidentApplicationApplicantInfoService(
  applicationId: string,
  client: ApiClient = apiClient,
) {
  return client.get<ResidentApplicationInfoModel>(
    `/residents/applications/${applicationId}/applicant-info`,
  );
}

export function fetchResidentApplicationUnitsAppliedService(
  applicationId: string,
  email: string,
  client: ApiClient = apiClient,
) {
  return client.get<string[]>(
    `/applicants/applications/${applicationId}/units-applied?email=${encodeURIComponent(email)}`,
  );
}

export function updateResidentApplicationApplicantStatusService(
  applicationId: string,
  applicantStatus: 'Started' | 'Submitted',
  client: ApiClient = apiClient,
) {
  return client.put<void>(`/residents/applications/${applicationId}/status`, {
    applicantStatus,
  });
}

export function fetchResidentApplicationCoSignerRequiredService(
  applicationId: string,
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<CoSignerRequiredModel>(
    `/residents/applications/${applicationId}/homes/${homeId}/co-signer-required`,
  );
}
